import { Node } from 'prosemirror-model';

export enum EventsEnum {
  ImageGeneration = 'IMAGE_GENERATION',
  KnowledgeDocCreation = 'KNOWLEDGE_DOC_CREATION',
  RedirectLinkUpdated = 'REDIRECT_LINK_UPDATED',
  CertificateSettingsUpdated = 'CERTIFICATE_SETTINGS_UPDATED',
}

export interface Events {
  [EventsEnum.ImageGeneration]: {
    node: Node;
    updateAttrs: (attrs: Object) => void;
  };
  [EventsEnum.KnowledgeDocCreation]: {};
  // Emitted by a micro-learning slide block (editor doc) whenever its own redirectLink
  // attribute changes, so app-level state (a separate doc/context) can track it.
  [EventsEnum.RedirectLinkUpdated]: {
    blockId: string;
    hasRedirectLink: boolean;
  };
  // Emitted by app-level micro-learning state whenever certificateSettings changes, so
  // slide blocks (editor doc) can disable their own redirect-link editing accordingly.
  [EventsEnum.CertificateSettingsUpdated]: {
    certificateEnabled: boolean;
  };
  // Index signature for unknown events
  [key: string]: unknown;
}

export type ImageGenerativeTaskEvent = Events[EventsEnum.ImageGeneration];
